export const isModuleSlotOverviewPath = (
    pathname: string,
    moduleId: `module_${string}`
): boolean => {
    const normalizedPath = pathname.replace(/\/+$/, '');
    return normalizedPath === `/modules/${moduleId}/slots`;
};

export const resolveBypassSlotOverview = (
    moduleSetting: boolean | undefined,
    studySetting: boolean | undefined
): boolean => moduleSetting ?? studySetting ?? false;
